<template>
  <div class="hr-sleek-tabs-container">
    <div class="hr-sleek-tabs">
      <button 
        class="hr-tab-btn" 
        :class="{ active: $route.name === 'report-daily' }"
        @click="$router.push({ name: 'report-daily' })"
        v-if="hasPermission('DAILY ATTENDANCE')"
      >
        <i class="bx bx-calendar-today"></i> Daily
      </button>

      <button 
        class="hr-tab-btn" 
        :class="{ active: $route.name === 'report-monthly-detailed' }"
        @click="$router.push({ name: 'report-monthly-detailed' })"
        v-if="hasPermission('DETAILED MONTHLY ATTENDANCE')"
      >
        <i class="bx bx-list-check"></i> Detailed Clock-ins
      </button>

      <button 
        class="hr-tab-btn" 
        :class="{ active: $route.name === 'report-monthly' }"
        @click="$router.push({ name: 'report-monthly' })"
        v-if="hasPermission('MONTHLY ATTENDANCE')"
      >
        <i class="bx bx-calendar-month"></i> Monthly Summary
      </button>

      <button 
        class="hr-tab-btn" 
        :class="{ active: $route.name === 'report-timesheet' }"
        @click="$router.push({ name: 'report-timesheet' })"
        v-if="hasPermission('TIMESHEET REPORT')"
      >
        <i class="bx bx-time-five"></i> Timesheets
      </button>

      <button 
        class="hr-tab-btn" 
        :class="{ active: $route.name === 'report-awol' }"
        @click="$router.push({ name: 'report-awol' })"
        v-if="hasPermission('AWOL REPORT')"
      >
        <i class="bx bx-user-x"></i> Unpaid Leave
      </button>

      <button 
        class="hr-tab-btn" 
        :class="{ active: $route.name === 'report-hr-report' }"
        @click="$router.push({ name: 'report-hr-report' })"
        v-if="hasPermission('HR REPORT')"
      >
        <i class="bx bx-building"></i> Dept. Report
      </button>

      <button 
        class="hr-tab-btn" 
        :class="{ active: $route.name === 'report-leave' }"
        @click="$router.push({ name: 'report-leave' })"
        v-if="hasPermission('LEAVE REPORT')"
      >
        <i class="bx bx-plane-alt"></i> Leave Report
      </button>
    </div>
  </div>
</template>

<script>
import { getRight } from '@/api';

export default {
  name: 'ReportTabs',
  methods: {
    hasPermission(permission) {
      return getRight(permission);
    }
  }
}
</script>

<style scoped>
.hr-sleek-tabs-container {
  margin-top: 20px;
}

.hr-sleek-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  border-bottom: 1px solid #e2e8f0;
}

.hr-tab-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 4px;
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  border-radius: 0;
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: -1px; /* Overlap the container border-bottom */
}

.hr-tab-btn i {
  font-size: 16px;
}

.hr-tab-btn:hover {
  color: #334155;
  border-bottom-color: #cbd5e1;
}

.hr-tab-btn.active {
  color: #4f46e5;
  font-weight: 600;
  border-bottom-color: #4f46e5;
}

.hr-tab-btn.active i {
  color: #4f46e5;
}
</style>
